import { APIRoute } from '@/modules/utils'
import { PartnerWebContent } from '@/data'
import { IRI } from 'emt-library'

export const GetPartnerQuoteRoute = (webContentIRI: IRI): APIRoute => ({
  method: 'GET',
  path: webContentIRI,
})
export const GetHelperRoute = (insuranceSlug: string): APIRoute => ({
  method: 'GET',
  path: `/v2/web_contents/${insuranceSlug}_helper`,
})
export const GetRefusedRoute = (insuranceSlug: string): APIRoute => ({
  method: 'GET',
  path: `/v2/web_contents/${insuranceSlug}_refused`,
})
export const GetSuccessRoute = (iri: IRI): APIRoute => ({
  method: 'GET',
  path: iri,
})

export type Response = PartnerWebContent
